export default "__VITE_ASSET__Dg_6iVmC__"